import { Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import InputField from "../forms/input-field";
import "../../components/customer-information/customer-information.css";
import TextAreaField from "../forms/textarea-field";
import { useDispatch } from "react-redux";

import AddButton, { DeleteButton } from "../buttons/button";
import { pincodeListAction } from "../../redux/actions/general-action";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  doctorCreateAction,
  doctorDeleteAction,
  doctorEditAction,
} from "../../redux/actions/doctor-action";
import { specializationSearchListAction } from "../../redux/actions/settings-action";
import SelectField from "../forms/select-field";

const DoctorCreateViewEdit = ({ doctor, disabled = false, page = "add" }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [specilizationList, setSpecilizationList] = useState([]);
  const doctorName = searchParams.get("doctor") || "";
  console.log("doctor", doctorName);
  const draft = searchParams.get("draft");
  const navigate = useNavigate();
  const initialValues = {
    dr_name: doctorName || (doctor?.dr_name ?? ""),
    dr_email: doctor?.dr_email ?? "",
    dr_specialization: doctor?.dr_specialization ?? "",
    dr_registration_num: doctor?.dr_registration_num ?? "",
    dr_qualification: doctor?.dr_qualification ?? "",
    dr_street1: doctor?.dr_street1 ?? null,
    dr_street2: doctor?.dr_street2 ?? null,
    dr_city: doctor?.dr_city ?? "",
    dr_state: doctor?.dr_state ?? "",
    dr_pincode: doctor?.dr_pincode ?? "",
    dr_hospital: doctor?.dr_hospital ?? "",
    dr_area: doctor?.dr_area ?? "",
    areaList: [],
  };

  const validationSchema = Yup.object().shape({
    dr_name: Yup.string().required("Doctor name is required!"),
    dr_email: Yup.string().email("Invalid email"),
    dr_specialization: Yup.string(),
    dr_registration_num: Yup.string(),
    dr_qualification: Yup.string(),
    dr_street1: Yup.string().nullable(),
    dr_street2: Yup.string().nullable(),
    dr_city: Yup.string(),
    dr_state: Yup.string(),
    dr_pincode: Yup.string(),
    dr_hospital: Yup.string(),
    dr_area: Yup.string(),
  });
  const onSubmit = (values, { resetForm }) => {
    let actionType = doctorCreateAction;
    if (page === "edit") {
      actionType = doctorEditAction;
    }
    dispatch(
      actionType(
        {
          dr_id: doctor?.dr_id,
          dr_name: values?.dr_name ?? "",
          dr_email: values?.dr_email ?? "",
          dr_specialization: values?.dr_specialization ?? "",
          dr_registration_num: values?.dr_registration_num ?? "",
          dr_qualification: values?.dr_qualification ?? "",
          dr_street1: values?.dr_street1 ?? null,
          dr_street2: values?.dr_street2 ?? null,
          dr_city: values?.dr_city ?? "",
          dr_state: values?.dr_state ?? "",
          dr_pincode: values?.dr_pincode ?? "",
          dr_area: values?.dr_area ?? "",
        },
        onSuccess,
        onError
      )
    );
  };

  const onSuccess = (data) => {
    if (doctorName) {
      navigate(
        `/edit-bill/${draft}?doctor=${data?.data?.dr_name}&doctorId=${data?.data?.dr_id}`
      );
    } else {
      navigate("/doctor");
    }
    successToast(data?.data?.message);
  };
  const onError = (data) => {
    errorToast(data?.message);
  };
  const handleVoidAction = (id) => {
    dispatch(
      doctorDeleteAction(
        {
          dr_id: id,
        },
        onSuccessDel,
        onErrorDel
      )
    );
  };

  const onSuccessDel = () => {
    navigate("/doctor");
  };
  const onErrorDel = () => {};

  function fetchAddressFn(inputValue, setFieldValue) {
    if (inputValue?.length === 6) {
      dispatch(
        pincodeListAction(
          inputValue,
          (response) => {
            if (response?.[0]?.Status === "Error") {
            } else {
              const firstPostOffice = response?.[0]?.PostOffice?.[0];
              setFieldValue("dr_state", firstPostOffice?.State);
              setFieldValue("dr_city", firstPostOffice?.District);
              setFieldValue(
                "areaList",
                response?.[0]?.PostOffice?.map((item) => ({
                  label: item?.Name,
                  value: item?.Name,
                }))
              );
            }
          },
          (data) => {
            setFieldValue("dr_state", "");
            setFieldValue("dr_city", "");
          }
        )
      );
    } else {
      setFieldValue("dr_state", "");
      setFieldValue("dr_city", "");
    }
  }
  const onSpecialSuccess = (data) => {
    setSpecilizationList(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };

  const onSpecialError = (data) => {
    errorToast(data?.data?.message);
  };
  useEffect(() => {
    dispatch(
      specializationSearchListAction("", onSpecialSuccess, onSpecialError)
    );
  }, []);
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => {
        return (
          <Form className="h-full pt-5">
            <CreateAreaList />

            <div className="flex flex-col justify-between h-full ">
              <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 xl:w-[40%] px-9">
                  <InputField
                    isDisabled={disabled}
                    containerClass="mb-2 position-relative w-full"
                    type="text"
                    name="dr_name"
                    placeholder="Enter name"
                    label="Name"
                    isRequired={true}
                    labelWidth="9rem"
                  />
                  <InputField
                    onKeyDown={() => {}}
                    isDisabled={disabled}
                    type="text"
                    name="dr_email"
                    placeholder="Enter E-mail"
                    label="Email"
                    isRequired={false}
                    labelWidth="9rem"
                  />

                  <SelectField
                    containerClass="flex-1"
                    placeholder="Select Specialization"
                    options={specilizationList}
                    label="Specialization"
                    id="dr_specialization"
                    name="dr_specialization"
                    isSearchable={true}
                    // errMsgContainerClass="ps-2"
                    // isRequired={true}
                    labelWidth="9rem"
                    isDisabled={disabled}
                  />

                  <InputField
                    type="text"
                    name="dr_qualification"
                    placeholder="Enter qualification"
                    label="Qualification"
                    labelWidth="9rem"
                  />
                  <InputField
                    type="text"
                    name="dr_hospital"
                    placeholder="Enter Hospital/Clinic"
                    label="Hospital/Clinic"
                    labelWidth="9rem"
                  />
                  <InputField
                    type="text"
                    name="dr_registration_num"
                    placeholder="Enter reg no."
                    label="Registration number"
                    labelWidth="9rem"
                  />
                </div>
                <div class="w-full lg:w-1/2 xl:w-[40%] px-9">
                  <InputField
                    labelWidth="9rem"
                    isDisabled={disabled}
                    type="text"
                    name="dr_pincode"
                    placeholder="Enter pincode"
                    label="Pin code"
                    isRequired={false}
                    handleChange={(e) => {
                      fetchAddressFn(e?.target?.value, setFieldValue);
                    }}
                  />
                  <>
                    <InputField
                      labelWidth="9rem"
                      isDisabled={true}
                      type="text"
                      name="dr_state"
                      placeholder="Enter State"
                      label="State"
                      isRequired={false}
                    />
                    <InputField
                      labelWidth="9rem"
                      isDisabled={true}
                      type="text"
                      name="dr_city"
                      placeholder="Enter city"
                      label="City"
                      isRequired={false}
                    />
                    {/* <InputField
                      labelWidth="9rem"
                      isDisabled={true}
                      type="text"
                      name="dr_area"
                      placeholder="Enter Area"
                      label="Area"
                      isRequired={false}
                    /> */}

                    <SelectField
                      containerClass="flex-1"
                      placeholder="Select Area"
                      options={values.areaList}
                      label="Area"
                      id="dr_area"
                      name="dr_area"
                      isSearchable={true}
                      // errMsgContainerClass="ps-2"
                      // isRequired={true}
                      labelWidth="9rem"
                      isDisabled={disabled}
                    />
                    <TextAreaField
                      labelWidth="9rem"
                      isDisabled={disabled}
                      label="Address 1"
                      placeholder="Enter address 1"
                      name="dr_street1"
                      id={"dr_street1"}
                      isRequired={false}
                    />
                    <TextAreaField
                      labelWidth="9rem"
                      isDisabled={disabled}
                      label="Address 2"
                      placeholder="Enter address 2"
                      name="dr_street2"
                      id={"dr_street2"}
                    />
                  </>
                  {/* {loading ? (
                    <LoadingSpinner />
                  ) : (
                   
                  )} */}
                </div>
              </div>
              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-between px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  {page !== "add" ? (
                    <DeleteButton
                      onclkFn={() => handleVoidAction(doctor?.dr_id)}
                      prefixIcon={false}
                      type="button"
                    />
                  ) : (
                    <div></div>
                  )}

                  <AddButton prefixIcon={false} text="Save" type="submit" />
                </div>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default DoctorCreateViewEdit;

const CreateAreaList = () => {
  const { setFieldValue, initialValues } = useFormikContext();
  const pincode = initialValues.dr_pincode;
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAddressInitially = () => {
      // Only proceed if pincode is exactly 6 digits
      if (pincode?.length !== 6) return;

      dispatch(
        pincodeListAction(
          pincode,
          (response) => {
            const postOffices = response?.[0]?.PostOffice;
            if (response?.[0]?.Status !== "Error" && postOffices) {
              const areaOptions = postOffices.map((item) => ({
                label: item.Name,
                value: item.Name,
              }));
              setFieldValue("areaList", areaOptions);
            }
          },
          () => {} // Error callback
        )
      );
    };

    // Call the function immediately when component mounts
    fetchAddressInitially();
  }, []); // Empty dependency array to run only once on mount

  return null;
};
